/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unexpected-multiline */
/* eslint-disable comma-dangle */

export default {
  init() {

    // Banenr Resize on Scroll
    if ($(window).width() > 1024) {
      $(document).on("scroll", function() {
        if($(document).scrollTop()>400) {
          $(".banner").addClass("smaller");
        } else {
          $(".banner").removeClass("smaller");
        }
      });
    }

    // JavaScript to be fired on the studio page
    $('.line-1').addClass('active');
    $('.line-1').each(function () {
        var characters = $(this).text().split("");
        var $this = $(this);
        $this.empty();
        $.each(characters, function (i, el) {
          if(el.indexOf(' ') > -1) {
            el = '<span class="spacer"></div>';
          }
          $this.append("<span class='animated-letter slowly-appear'>" + el + "</span");
        });
    });
    setTimeout(function(){
      $('.line-2').addClass('active');
      $('.line-2').each(function () {
          var characters = $(this).text().split("");
          var $this = $(this);
          $this.empty();
          $.each(characters, function (i, el) {
            if(el.indexOf(' ') > -1) {
              el = '<span class="spacer"></div>';
            }
            $this.append("<span class='animated-letter slowly-appear'>" + el + "</span");
          });
      });
    }, 500);
    setTimeout(function(){
      $('.line-3').addClass('active');
      $('.line-3').each(function () {
          var characters = $(this).text().split("");
          var $this = $(this);
          $this.empty();
          $.each(characters, function (i, el) {
            if(el.indexOf(' ') > -1) {
              el = '<span class="spacer"></div>';
            }
            $this.append("<span class='animated-letter slowly-appear'>" + el + "</span");
          });
      });
    }, 1000);

    function new_map( $el ) {
      var $markers = $el.find('.marker');
      var args = {
         zoom	: 12,
         center	: new google.maps.LatLng(0, 0),
         mapTypeId: google.maps.MapTypeId.ROADMAP,
         mapTypeControl: false,
         streetViewControl: false,
         // disableDefaultUI: true,
         // gestureHandling: 'greedy',
         styles:
         [
             {
                 "featureType": "all",
                 "elementType": "labels.text.fill",
                 "stylers": [
                     {
                         "saturation": 36
                     },
                     {
                         "color": "#000000"
                     },
                     {
                         "lightness": 40
                     }
                 ]
             },
             {
                 "featureType": "all",
                 "elementType": "labels.text.stroke",
                 "stylers": [
                     {
                         "visibility": "on"
                     },
                     {
                         "color": "#000000"
                     },
                     {
                         "lightness": 16
                     }
                 ]
             },
             {
                 "featureType": "all",
                 "elementType": "labels.icon",
                 "stylers": [
                     {
                         "visibility": "off"
                     }
                 ]
             },
             {
                 "featureType": "administrative",
                 "elementType": "geometry.fill",
                 "stylers": [
                     {
                         "color": "#000000"
                     },
                     {
                         "lightness": 20
                     }
                 ]
             },
             {
                 "featureType": "administrative",
                 "elementType": "geometry.stroke",
                 "stylers": [
                     {
                         "color": "#000000"
                     },
                     {
                         "lightness": 17
                     },
                     {
                         "weight": 1.2
                     }
                 ]
             },
             {
                 "featureType": "landscape",
                 "elementType": "geometry",
                 "stylers": [
                     {
                         "color": "#000000"
                     },
                     {
                         "lightness": 20
                     }
                 ]
             },
             {
                 "featureType": "poi",
                 "elementType": "geometry",
                 "stylers": [
                     {
                         "color": "#000000"
                     },
                     {
                         "lightness": 21
                     }
                 ]
             },
             {
                 "featureType": "road.highway",
                 "elementType": "geometry.fill",
                 "stylers": [
                     {
                         "color": "#000000"
                     },
                     {
                         "lightness": 17
                     }
                 ]
             },
             {
                 "featureType": "road.highway",
                 "elementType": "geometry.stroke",
                 "stylers": [
                     {
                         "color": "#000000"
                     },
                     {
                         "lightness": 29
                     },
                     {
                         "weight": 0.2
                     },
                 ],
             },
             {
                 "featureType": "road.arterial",
                 "elementType": "geometry",
                 "stylers": [
                     {
                         "color": "#000000"
                     },
                     {
                         "lightness": 18
                     },
                 ],
             },
             {
                 "featureType": "road.local",
                 "elementType": "geometry",
                 "stylers": [
                     {
                         "color": "#000000"
                     },
                     {
                         "lightness": 16
                     },
                 ],
             },
             {
                 "featureType": "transit",
                 "elementType": "geometry",
                 "stylers": [
                     {
                         "color": "#000000"
                     },
                     {
                         "lightness": 19
                     },
                 ],
             },
             {
                 "featureType": "water",
                 "elementType": "geometry",
                 "stylers": [
                     {
                         "color": "#000000"
                     },
                     {
                         "lightness": 17
                     },
                 ],
             },
         ],
      };
      var map = new google.maps.Map( $el[0], args);
      // add a markers reference
      map.markers = [];
      // add markers
      $markers.each(function(){
          add_marker( $(this), map );
      });
      // center map
      center_map( map );


      // return
      return map;

    }

    /*
    *  add_marker
    *
    *  This function will add a marker to the selected Google Map
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	$marker (jQuery element)
    *  @param	map (Google Map object)
    *  @return	n/a
    */

    function add_marker( $marker, map ) {

      // var
      var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

      // create marker
      var icon = {
          url: '../wp-content/themes/soren/resources/assets/images/marker.svg',
          scaledSize: new google.maps.Size(50, 50), // scaled size
          origin: new google.maps.Point(0,0), // origin
          anchor: new google.maps.Point(0, 0) // anchor
      };

      var marker = new google.maps.Marker({
          position: latlng,
          map: map,
          icon: icon
      });

      // add to array
      map.markers.push( marker );

      // if marker contains HTML, add it to an infoWindow
      if( $marker.html() )
      {
        // create info window
        var infowindow = new google.maps.InfoWindow({
          content		: $marker.html(),
        });

        // show info window when marker is clicked
        google.maps.event.addListener(marker, 'click', function() {
          infowindow.open( map, marker );
        });
      }

    }

    /*
    *  center_map
    *
    *  This function will center the map, showing all markers attached to this map
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	map (Google Map object)
    *  @return	n/a
    */

    function center_map( map ) {

      // vars
      var bounds = new google.maps.LatLngBounds();

      // loop through all markers and create bounds
      $.each( map.markers, function( i, marker ){

        var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

        bounds.extend( latlng );

      });

      // only 1 marker?
      if( map.markers.length == 1 )
      {
        // set center of map
          map.setCenter( bounds.getCenter() );
          map.setZoom( 13 );
      }
      else
      {
        // fit to bounds
        // map.fitBounds( bounds );
        map.setCenter( new google.maps.LatLng(38.850033, -100.6500523));
        map.setZoom( 4 );
      }

    }
    var map = null;

    $(document).ready(function(){

      $('.acf-map').each(function(){

        // create map
        map = new_map( $(this) );

      });

    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js